import { AdditionalSavingsOptionsType, GenderOptionType } from '../../../utils/constants';

interface Child {
  date_of_birth: string
}

export interface BaseProductRecommendationPayload {
  name: string
  date_of_birth: string
  gender: GenderOptionType
  net_income: number
  additional_savings: AdditionalSavingsOptionsType[]
  children: Child[]
  monthly_savings: number | null
  savings_with_insurance: boolean
}

export type ProductKind = 'apv_with_insurance' | 'apv_full_flexible' | 'apv_insured_university' | 'apv_start' | 'apv_bi' | 'bice_life_plan' | 'rrvv' | 'protection' | 'health' | 'asset_advisory';

export enum ProductKindEnum {
  MUTUAL_FUNDS = 'MUTUAL_FUNDS',
  RECOMMENDED_PORTFOLIOS = 'RECOMMENDED_PORTFOLIOS',
  ASSET_MANAGEMENT = 'ASSET_MANAGEMENT',
  APV = 'APV',
  INSURANCE = 'INSURANCE',
  INTERNATIONAL_MARKET = 'INTERNATIONAL_MARKET',
  ALT_ASSETS = 'ALT_ASSETS',
  RRVV_RRPP = 'RRVV_RRPP',
  MUTUAL_FUNDS_LIQUIDITY_BICE_CLP = 'MUTUAL_FUNDS_LIQUIDITY_BICE_CLP',
  MUTUAL_FUNDS_LIQUIDITY_BICE_USD = 'MUTUAL_FUNDS_LIQUIDITY_BICE_USD',
  ASSET_RECOMMENDATION = 'ASSET_RECOMMENDATION',
}

export interface Product {
  description: string
  image: string
  kind: Exclude<ProductKind, 'asset_advisory'>
  url: string
}

export interface ProductRecommendationResponse extends BaseProductRecommendationPayload {
  result_products: Product[]
  result_interests: Product[]
}

export type TextMode = 'rich' | 'text';
export interface ProductRenderInfo {
  defaultImgSrc: (hasInsurance: boolean) => string,
  iconSrc: string,
  description?: string,
  hideButton?: boolean
  buttonText?: string,
  benefits: (mode: TextMode) => JSX.Element[]
  complementaryInfo: (hasInsurance: boolean) => JSX.Element
}
